import { render, staticRenderFns } from "./Overdues.vue?vue&type=template&id=5dfd9dab&scoped=true&"
import script from "./Overdues.vue?vue&type=script&lang=js&"
export * from "./Overdues.vue?vue&type=script&lang=js&"
import style0 from "./Overdues.vue?vue&type=style&index=0&id=5dfd9dab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd9dab",
  null
  
)

export default component.exports